import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { Attachment } from '../reference/attachment.js';
export const DailyReportEntryTypes = {
    announcement: 'announcement',
    activity: 'activity',
    bathroom: 'bathroom',
    documentation: 'documentation',
    food: 'food',
    health: 'health',
    mealDistribution: 'mealDistribution',
    media: 'media',
    medication: 'medication',
    medicationNote: 'medicationNote',
    teachActivity: 'teachActivity',
    teachDayHeader: 'teachDayHeader',
    nap: 'nap',
    note: 'note',
    sdcAssessment: 'sdcAssessment',
    skinApplication: 'skinApplication',
    unknown: 'unknown'
};
export const DailyReportEntryType = Type.Union([
    Type.Literal(DailyReportEntryTypes.announcement),
    Type.Literal(DailyReportEntryTypes.activity),
    Type.Literal(DailyReportEntryTypes.bathroom),
    Type.Literal(DailyReportEntryTypes.documentation),
    Type.Literal(DailyReportEntryTypes.food),
    Type.Literal(DailyReportEntryTypes.health),
    Type.Literal(DailyReportEntryTypes.mealDistribution),
    Type.Literal(DailyReportEntryTypes.media),
    Type.Literal(DailyReportEntryTypes.medication),
    Type.Literal(DailyReportEntryTypes.medicationNote),
    Type.Literal(DailyReportEntryTypes.teachActivity),
    Type.Literal(DailyReportEntryTypes.teachDayHeader),
    Type.Literal(DailyReportEntryTypes.nap),
    Type.Literal(DailyReportEntryTypes.note),
    Type.Literal(DailyReportEntryTypes.sdcAssessment),
    Type.Literal(DailyReportEntryTypes.skinApplication),
    Type.Literal(DailyReportEntryTypes.unknown)
]);
export const DailyReportEntryTypeCodec = createFallbackStringEnumCodec(DailyReportEntryTypes, DailyReportEntryTypes.unknown);
export const DailyReportEntry = Type.Object({
    id: Type.String({ minLength: 1 }),
    typeName: DailyReportEntryTypeCodec,
    v: Type.Optional(Type.Integer()),
    edited: Type.Boolean(),
    deleted: Type.Boolean(),
    parent: Type.Boolean(),
    fp: Type.Optional(Type.Boolean()),
    clientUpdateTimestamp: Type.Number(),
    captureTime: Type.Optional(Type.Number()),
    actionTime: Type.Optional(Type.Number()),
    note: Type.Optional(Type.String()),
    stage: Type.Optional(Type.String()),
    owner: Type.Optional(Type.String({ minLength: 1 })),
    actor: Type.Optional(Type.String({ minLength: 1 })),
    editors: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
    attachment: Type.Optional(Attachment),
    canShareAttachment: Type.Boolean(),
    linkId: Type.Optional(Type.String({ minLength: 1 })),
    removedLinkId: Type.Optional(Type.String({ minLength: 1 })),
    triggerEvent: Type.Optional(Type.Boolean()),
    reminderPeriod: Type.Optional(Type.Integer())
});
